import { Injectable } from "@angular/core";
import { BaseApiService } from "../shared/_base.api.service";
import { FilterType } from "../../utils/types/shared/_filter.type";
import { PagedApiResponse } from "../../utils/types/shared/_paged-api-response.type";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { CompanyMapper } from "../../utils/mappers/admon/company.mapper";
import { COMPANY_ENDPOINTS } from "../../components/mediaManager/admon/company/company-endpoints";
import { Company } from "../../utils/types/admon/company.type";
import { HttpHeaders, HttpParams } from "@angular/common/http";

@Injectable({ providedIn: "root" })
export class CompanyService extends BaseApiService<Company> {
    model = Company;
    mapper = new CompanyMapper();
    apiEndPoint: any = COMPANY_ENDPOINTS;

    save(data: any): Observable<any> {
        return this.http.put(this.apiEndPoint.save, data).pipe(
            map((res) => {
                return res;
            })
        );
    }

    get(id: number): Observable<any> {
        return this.http.get(this.apiEndPoint.item.replace("{id}", id)).pipe(
            map((res) => {
                return res;
            })
        );
    }

    getList(filter?: any): Observable<PagedApiResponse<Company>> {
        let params = new HttpParams();

        if (
            (filter?.offset !== null || filter?.offset !== undefined) &&
            filter?.limit
        ) {
            params = params.append("offset", filter.offset);
            params = params.append("limit", filter.limit);
        }

        if (filter.active) {
            params = params.append("active", filter.active);
        }

        return this.http.get(this.apiEndPoint.list, { params }).pipe(
            map((res) => {
                return this.sharedMapper.mapPagedApiResponse(
                    res,
                    this.mapper.mapList,
                    this.model
                );
            })
        );
    }

    getListByCompanyId(
        filter?: FilterType,
        companyId?: number
    ): Observable<PagedApiResponse<Company>> {
        let params = new HttpParams();

        if (
            (filter?.offset !== null || filter?.offset !== undefined) &&
            filter?.limit
        ) {
            params = params.append("offset", filter.offset);
            params = params.append("limit", filter.limit);
        }

        return this.http
            .get(this.apiEndPoint.itemList.replace("{id}", companyId), {
                params,
            })
            .pipe(
                map((res) => {
                    return this.sharedMapper.mapPagedApiResponse(
                        res,
                        this.mapper.mapList,
                        this.model
                    );
                })
            );
    }

    getListCompaniesParent(): Observable<Array<any>> {
        return this.http.get(this.apiEndPoint.listParents).pipe(
            map((res: any) => {
                return res;
                //return this.mapper.mapList(res.rows, Company);
            })
        );
    }

    create(data: Company): Observable<any> {
        //data.userId = AuthenticationService.getCurrentUserInformation().id;
        return this.http.post<any>(this.apiEndPoint.list, data).pipe(
            map((res) => {
                return res;
            })
        );
    }

    update(data: Company): Observable<boolean> {
        return this.http.put<boolean>(
            this.apiEndPoint.item.replace("{id}", data.id.toString()),
            data
        );
    }
}
